import * as React from 'react';

export interface RangeProps {
  /** Accept any component as a child item. At the moment it is most commonly used with `<DatePicker/>` or `<Input/>`*/
  children?: React.ReactNode;
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook?: string;
}

export class Range extends React.Component<RangeProps> {}
